module.exports = __webpack_public_path__ + "static/media/dashboard-marketplace-category2.436e1b64.svg";